import Imports from '../views/Imports'
export default [
  {
    path: '/admin/imports',
    name: 'imports',
    component: Imports
  }
]
